import React from 'react';

import TwitterLogo from '../TwitterLogo';

import './appheader.scss';

export default ({ style, backgroundColor, logoColor }) => {
  return (
    <div className="app-header">
      <div className="app-header__logo">
        <TwitterLogo style={style} background={backgroundColor} color={logoColor} />
      </div>
    </div>
  );
};
